module.exports = __webpack_public_path__ + "static/media/outline-cactus-green.8b804425.svg";